module.exports = __webpack_public_path__ + "media/icons/notification_close-06877fdb.png";